import React from 'react';

import Loadable from 'react-loadable';
import {Route} from 'react-router-dom';

import LoadingSpinner from 'static/three-oh/src/components/LoadingSpinner/LoadingSpinner';

const LazyPollContainer = Loadable({
  loader: () => import(
    /* webpackChunkName: "StandalonePoll" */
    './components/StandalonePoll'
  ),
  delay: 1000,
  // eslint-disable-next-line
  loading: (props) => (props.pastDelay ? <LoadingSpinner /> : null)
});

const PollRoute = (
  <Route
    path="/polls/:pollSlug"
    component={LazyPollContainer}
  />
);

export default PollRoute;
